import React, { useState, useEffect } from 'react';
import './assets/scss/styles.scss';
import { Container } from 'react-bootstrap';
import { cleanArrayUndefined, getCurrentLanguage, groupBy, translate } from '../../assets/js/functions';
import { getTestimoniosMapsMarks } from '../../assets/js/api';
import proj4 from 'proj4';

export default function MapTestimonios(props){
    // const [resultCount, setResultCount] = useState(0)
    const [loading, setLoading] = useState(true);

    var map = null;

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://sitna.tracasa.es/api/";
        script.async = true;
        script.onload = () => scriptLoaded();

        document.body.appendChild(script);
    }, [])

    function scriptLoaded(){
        var SITNA = window.SITNA;

        proj4.defs('EPSG:25830', "+proj=utm +zone=30 +ellps=GRS80 +units=m +no_defs");
        proj4.defs('EPSG:4326', "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs");

        map = new SITNA.Map("mapa", {
        });

        getTestimoniosMapsMarks().then((res) => {
                const dataMap = res.data.result.map(
                    mark =>{ if(mark.space && JSON.parse(mark.space).lon) return mark }
                )

                setLoading(false);

                var arr = groupBy(cleanArrayUndefined(dataMap), 'location');

                map.loaded(function () {
                    var arrMarks = [];
                    let currentData = null;
                    let locations = []
                    arr = (Object.values(arr))
                    arr.map(
                        res => {
                            res.map(
                                val => {
                                    // setResultCount(prev => prev + 1);
                                    currentData = "<div class='marker-data'>"+
                                                        "<div class='title'>"+
                                                            "<h2>"+val.term+"</h2>"+
                                                        "</div>"+
                                                        "<div class='buttons'>"+
                                                            "<a href=/"+getCurrentLanguage()+"/interviews/explore/"+val.term_id+" target='_blank'>"+translate("Ver entrevista")+"</a>"+
                                                            (val.external_uri ? "<a href="+JSON.parse(val.external_uri)[0].iri+" target='_blank'>"+translate("Ver ficha")+"</a>" : "")+
                                                        "</div>"+
                                                    "</div>"
                                        arrMarks.push(currentData);
                                        locations = JSON.parse(val.location_map) ? [parseFloat(JSON.parse(val.location_map).lon), parseFloat(JSON.parse(val.location_map).lat)] : [parseFloat(JSON.parse(val.space).lon), parseFloat(JSON.parse(val.space).lat)];
                                }
                            )
                            var locUTM = proj4('EPSG:4326', 'EPSG:25830', locations);



                            map.addMarker(locUTM, {
                                data: arrMarks,
                                width: 22,
                                cssClass: "tc-marker2"
                            })
                            arrMarks = [];
                            locations = [];
                        }
                    )
                    map.zoomToMarkers({extentMargin: 0});
                })
            }
        )
    }


    return (
        <Container>
            <div style={{height: "60vh"}}>
                {loading
                    ? <div className="loader1"><div></div><div></div></div>
                    // : <p class="result_count">{translate("Resultados").toUpperCase() + ' ' + resultCount}</p>
                    : ''
                }
                <div id="mapa"></div>
            </div>
        </Container>
    )
}
